import i18next from 'i18next'
import * as React from 'react'
import { Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { getFSClassName } from '../utils/getClassNameFromStyle'
import { formSkeletonClasses, FormSkeletonStyle } from './style'

// ==========================================================================
// CONFIG
// ==========================================================================

export const formSkeletonConfig: FormSkeletonConfigProps = {
  options: { style: formSkeletonClasses },
  rootUrl: '/spa',
  sloganClassName: '',
  preferredColorScheme: 'dark',
  colorSchemeLight: {
    logoSrc: '',
    image: {
      src: '',
      srcSet: ''
    }
  },
  colorSchemeDark: {
    logoSrc: '',
    image: {
      src: '',
      srcSet: ''
    }
  }
}

// ==========================================================================
// FORM SKELETON
// ==========================================================================

type FormSkeletonConfigProps = {
  options: { style: FormSkeletonStyle }
  rootUrl: string
  sloganClassName?: string
  preferredColorScheme?: FormSkeletonColorModes | 'none'
  colorSchemeLight: FormSkeletonColorSchemeProps
  colorSchemeDark: FormSkeletonColorSchemeProps
}

type FormSkeletonColorSchemeProps = {
  logoSrc: string
  image: {
    src: string
    srcSet?: string
  }
}

type FormSkeletonColorModes = 'light' | 'dark'

// ----- STRUCTURE

export type FormTypes =
  | 'sign-up'
  | 'sign-up-succes'
  | 'login'
  | 'reset-password-request'
  | 'reset-password-request-success'
  | 'reset-password'
  | 'reset-password-success'
  | 'resend-activation'
  | 'resend-activation-success'
  | 'trial-to-pro'
  | 'trial-to-pro-success'
  | 'trial-to-pro-failed'
  | 'redirect-to-psp'
  | 'activate-account'
  | 'activate-account-success'
  | 'activate-account-failed'
  | 'activate-change-password'
  | 'student-subscription'
  | 'change-password'
  | 'change-password-success'

export type FormSkeletonProps = {
  type: FormTypes
  children: React.ReactNode
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void
  slogan?: string
  colorScheme: FormSkeletonColorModes
  modifier?: string
  rootUrl?: string
} & ({ kind: 'text' } | { kind: 'text-image'; image: { src: string; srcSet?: string } })

export const FormSkeletonLayout = (p: FormSkeletonProps) => {
  const { children, colorScheme, kind, modifier, onSubmit, slogan, type, rootUrl } = p
  const { colorSchemeDark, colorSchemeLight, preferredColorScheme, sloganClassName } = formSkeletonConfig
  const isDarkMode = formSkeletonConfig.preferredColorScheme == 'dark' || colorScheme == 'dark'
  return (
    <div
      key={`auth-${type}-form`}
      className={`auth auth--${type} auth--${kind}${modifier ? ` auth--${modifier}` : ''}${
        isDarkMode ? ' auth--clr-inverted' : ''
      }`}
    >
      {/* <header className='auth__header'>
        <div className='auth__header-inner'>
          <Link
            to={rootUrl || formSkeletonConfig.rootUrl}
            className='auth__logo'
            title={i18next.t('a11y:navigateHome')}
          >
            <span className='sr-text'>{i18next.t('a11y:navigateHome')}</span>
            <img src={isDarkMode ? colorSchemeDark.logoSrc : colorSchemeLight.logoSrc} alt='' />
          </Link>

          {slogan && <p className={`auth__slogan ${sloganClassName || ''}`}>{slogan}</p>}
        </div>

        {p.kind === 'text-image' ? (
          preferredColorScheme == 'dark' ? (
            <FormSkeletonImage {...colorSchemeDark.image} />
          ) : preferredColorScheme == 'light' ? (
            <FormSkeletonImage {...colorSchemeLight.image} />
          ) : (
            p.image && <FormSkeletonImage {...p.image} />
          )
        ) : (
          <div className='auth__visual' aria-hidden='true' />
        )}
      </header> */}

      <main className={`auth__main ${getFSClassName('blockClassName', 'container')}`}>
        {onSubmit !== undefined ? (
          <FormSkeletonForm onSubmit={(e) => onSubmit(e)}>
            <Link
              to={rootUrl || formSkeletonConfig.rootUrl}
              className='auth__logo'
              title={i18next.t('a11y:navigateHome')}
            >
              <span className='sr-text'>{i18next.t('a11y:navigateHome')}</span>
              <img src={isDarkMode ? colorSchemeDark.logoSrc : colorSchemeLight.logoSrc} alt='' />
            </Link>

            <div className={`auth__form-inner ${getFSClassName('formInnerClassName')}`}>{children}</div>
          </FormSkeletonForm>
        ) : (
          <div className={`auth__form ${getFSClassName('formClassName')}`}>
            <Link
              to={rootUrl || formSkeletonConfig.rootUrl}
              className='auth__logo'
              title={i18next.t('a11y:navigateHome')}
            >
              <span className='sr-text'>{i18next.t('a11y:navigateHome')}</span>
              <img src={isDarkMode ? colorSchemeDark.logoSrc : colorSchemeLight.logoSrc} alt='' />
            </Link>

            <div className={`auth__form-inner ${getFSClassName('formInnerClassName')}`}>{children}</div>
          </div>
        )}
      </main>
    </div>
  )
}

// export const FormSkeletonImage = (p: { src: string; srcSet?: string }) => (
//   <div className='auth__visual'>
//     <img
//       className='auth__image'
//       alt=''
//       src='https://giustoragev2.blob.core.windows.net/shoppinger/reuma-corpo/empty.png'
//       data-src={p.src}
//       data-srcset={p.srcSet || ''}
//       data-sizes='auto'
//     />
//   </div>
// )

export const FormSkeletonForm = (p: { onSubmit: (e: React.FormEvent<HTMLFormElement>) => void; children: React.ReactNode }) => (
  <Form noValidate onSubmit={p.onSubmit} className={`auth__form ${getFSClassName('formClassName')}`}>
    {p.children}
  </Form>
)
